<template>
  <div style="padding: 0 8px; position: relative">
    <a-button v-if="authorities.find(a => a.code === 'device:manage:device:export')" :loading="isExporting" type="primary" @click="exportData" style="position: absolute; top: -62px; right: 177px;">{{ $t('buttons.export') }}</a-button>
    <el-table :data="compressorList" v-loading="isTableLoading" height="815" style="margin-top: 10px;">
      <el-table-column prop="code" width="150">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">
            {{ $t('device.code') }}
          </div>
          <a-input allow-clear v-model.trim="query.code" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <a v-if="authorities.find(a => a.code === 'device:manage:device:update')" @click.stop="gotoDevice(scope.row)">
            <text-highlight :queries="highLightInfo.code">{{ scope.row.code }}</text-highlight>
          </a>
          <text-highlight v-else :queries="highLightInfo.code">{{ scope.row.code }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="name" width="150">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">
            {{ $t('common.deviceName') }}
          </div>
          <a-input allow-clear v-model.trim="query.name" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.name">{{ scope.row.name }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="model" width="120">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">
            {{ $t('common.model') }}
          </div>
          <a-input allow-clear v-model.trim="query.model" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.model">{{ scope.row.model }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="customer.company" width="300">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">
            {{ $t('customer.company') }}
          </div>
          <a-input allow-clear v-model.trim="query['customer.company']" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <a v-if="ca.find(a => a.code === 'customer:update')" @click.stop="$router.push({ path: '/customer/detail', query: { id: scope.row.customer.id } })">
            <text-highlight :queries="highLightInfo['customer.company']">{{ scope.row.company }}</text-highlight>
          </a>
          <text-highlight v-else :queries="highLightInfo['customer.company']">{{ scope.row.company }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="status" width="90">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">
            {{ $t('device.status') }}
          </div>
          <a-select style="width: 70px; font-weight: 400 !important" v-model="filters.status" @change="getCompressorList">
            <a-select-option value="">{{ $t('common.all') }}</a-select-option>
            <a-select-option v-for="(value, key) in deviceStatusTypeList" :key="key">{{ value }}</a-select-option>
          </a-select>
        </template>
        <template slot-scope="scope">
          <span v-for="(s, i) in scope.row.status" :key="s">
            <span :style="{ color: (s && runningStatus[s]) ? runningStatus[s].color : '' }">{{ (s && runningStatus[s]) ? runningStatus[s][lang] : '' }}</span>
            <span v-if="i < scope.row.status.length - 1">&nbsp;&nbsp;</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="organizations" width="240">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.organization') }}</div>
          <a-input allow-clear v-model.trim="query['customer.users.organizationName']" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo['customer.users.organizationName']">{{ scope.row.organizations }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="sOrganizations" width="240">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.sOrganization') }}</div>
          <a-input allow-clear v-model.trim="query['customer.serviceMans.organizationName']" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo['customer.serviceMans.organizationName']">{{ scope.row.sOrganizations }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="protocolCode" width="120">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('common.protocolCode') }}</div>
          <a-input allow-clear v-model.trim="query.protocolCode" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.protocolCode">{{ scope.row.protocolCode }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="dtuCode" width="110">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('common.dtuCode') }}</div>
          <a-input allow-clear v-model.trim="query.dtuCode" @keyup.enter="getCompressorList" />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.dtuCode">{{ scope.row.dtuCode }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="runTime" width="120">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.runTime') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.runTime.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.runTime.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="maintainTime" :width="lang === 'en' ? '120' : '110'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.maintainTime') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.maintainTime.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.maintainTime.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="maintainSettingTime" :width="lang === 'en' ? '170' : '110'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.maintainSettingTime') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.maintainSettingTime.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.maintainSettingTime.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exhaustPressure" :width="lang === 'en' ? '170' : '120'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('warning.exhaustPressure') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.exhaustPressure.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.exhaustPressure.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exhaustTemperature" :width="lang === 'en' ? '190' : '120'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('warning.exhaustTemperature') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.exhaustTemperature.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.exhaustTemperature.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="outputCurrent" :width="lang === 'en' ? '170' : '120'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('warning.outputCurrent') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.outputCurrent.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.outputCurrent.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="outputFrequency" :width="lang === 'en' ? '170' : '120'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('warning.outputFrequency') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.outputFrequency.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.outputFrequency.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="outputPower" :width="lang === 'en' ? '170' : '120'">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('warning.outputPower') }}</div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a-select style="width: 50%;" v-model="filterDatas.outputPower.req">
              <a-select-option
                v-for="r in reqList"
                :key="r.value"
              >
                {{ r.text }}
              </a-select-option>
            </a-select>
            <a-input style="width: 50%;" v-model="filterDatas.outputPower.value" @keyup.enter="getCompressorList" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="powerOnTime" width="120">
        <template #header>
          <div style="color: rgba(0,0,0,.85); font-weight: 500;">{{ $t('device.powerOnTime') }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="125">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
        </template>
        <template slot-scope="scope">
          <a-button style="padding-left: 0" type="link" @click="$router.push({
            name: 'history',
            params: {
              machineId: scope.row.code,
              machineType: scope.row.model,
              protocolCode: scope.row.protocolCode,
              id: scope.row.id
              // port_no: list[0].port_no
            }
          })" v-show="authorities.find(a => a.code === 'device:manage:device:history:query')">{{ $t('device.history') }}</a-button>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination @change="handlePageChange" style="float: right; margin-top: 20px; padding-bottom: 20px" v-model="pagination.current" :total="pagination.total" :page-size="100" show-less-items />
  </div>
</template>

<script>
import moment from 'moment'
import TextHighlight from 'vue-text-highlight'
import { getDict } from '@/api/dict'
import {
  searchDeviceList,
  exportDevice
} from '@/api/device'

export default {
  components: { TextHighlight },
  data() {
    return {
      authorities: [],
      ca: [],
      isTableLoading: false,
      isExporting: false,
      query: {
        code: '',
        name: '',
        model: '',
        'customer.company': '',
        'customer.users.organizationName': '',
        'customer.serviceMans.organizationName': '',
        protocolCode: '',
        dtuCode: ''
      },
      filters: {
        type: ["KYJ", "GFJ"],
        status: ''
      },
      filterDatas: {
        runTime: {
          req: 'eq',
          value: ''
        },
        maintainTime: {
          req: 'eq',
          value: ''
        },
        maintainSettingTime: {
          req: 'eq',
          value: ''
        },
        exhaustPressure: {
          req: 'eq',
          value: ''
        },
        exhaustTemperature: {
          req: 'eq',
          value: ''
        },
        outputCurrent: {
          req: 'eq',
          value: ''
        },
        outputFrequency: {
          req: 'eq',
          value: ''
        },
        outputPower: {
          req: 'eq',
          value: ''
        }
      },
      reqList: [
        {
          value: 'eq',
          text: '='
        },
        {
          value: 'ge',
          text: '≥'
        },
        {
          value: 'le',
          text: '≤'
        },
        {
          value: 'gt',
          text: '>'
        },
        {
          value: 'lt',
          text: '<'
        }
      ],
      highLightInfo: {
        code: '',
        name: '',
        model: '',
        'customer.company': '',
        'customer.users.organizationName': '',
        'customer.serviceMans.organizationName': '',
        protocolCode: '',
        dtuCode: ''
      },
      deviceStatusTypeList: {},
      runningStatus: {
        online: {
          color: "#0eed24",
          zh: "在线",
          en: 'Online'
        },
        running: {
          color: "#0eed24",
          zh: "运行",
          en: 'Running'
        },
        maintain: {
          color: "#ff681c",
          zh: "保养",
          en: 'Maintain'
        },
        error: {
          color: "#e82127",
          zh: "故障",
          en: 'Error'
        },
        standby: {
          color: "#11d7f5",
          zh: "停机",
          en: 'Standby'
        },
        sleep: {
          color: "#11d7f5",
          zh: "待机",
          en: 'Sleep'
        },
        offline: {
          color: "#4d4d4d",
          zh: "离线",
          en: 'Offline'
        },
        prepare: {
          color: "#4d4d4d",
          zh: "备机",
          en: 'Prepare'
        }
      },
      pagination: {
        current: 1,
        pageSize: 100,
        total: 0
      },
      compressorList: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.authorities = this.getAuthorities("/list")
    this.ca = this.getAuthorities('/customer')
    sessionStorage.setItem('authorities', JSON.stringify(this.authorities))
  },
  async mounted() {
    await this.getDeviceStatusList()
    await this.getCompressorList()
  },
  methods: {
    async getDeviceStatusList() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      const { data } = await getDict(lang, 'deviceStatus')
      this.deviceStatusTypeList = {}
      data.content.forEach(c => {
        this.deviceStatusTypeList[c.value] = c.text
      })
    },
    async getCompressorList(e) {
      this.isTableLoading = true
      try {
        if (e) {
          this.pagination.current = 1
        }
        const params = {
          query: [],
          filter: [],
          sort: [
            {
              field: 'updatedAt',
              value: 'desc'
            }
          ]
        }

        // let qFlag = false, fDFlag = false, fFlag = !!this.filters.status
        for (let key in this.query) {
          if (this.query[key]) {
            params.query.push({
              field: key,
              value: key === 'code' ? this.query[key].split('-').join('') : this.query[key]
            })
            // qFlag = true
          }
        }
        for (let fi in this.filters) {
          if (this.filters[fi]) {
            if (fi === "type") {
              params.filter.push({
                type: "or",
                properties: []
              })
              this.filters[fi].forEach(f => {
                params.filter[0].properties.push({
                  field: fi,
                  value: f
                })
              })
            } else {
              params.filter.push({
                field: fi,
                value: this.filters[fi]
              })
            }
          }
        }
        for (let f in this.filterDatas) {
          if (this.filterDatas[f].value) {
            params.filter.push({
              field: f,
              req: this.filterDatas[f].req,
              value: +this.filterDatas[f].value
            })
            // fDFlag = true
          }
        }
        // if (!qFlag && !fFlag && fDFlag) {
        //   return this.$message.warning(this.$t('device.searchTooltip'))
        // }
        params.filter.push({
          field: "mode",
          value: "and"
        })
        const { data: { current, total, size, records } } = await searchDeviceList(this.pagination.current, this.pagination.pageSize, params)
        this.compressorList = records.map(item => {
          item.organizations = [];
          item.users = [];
          item.mobiles = []
          item.company = item.customer?.company || '';
          item.sOrganizations = [];
          (item.customer?.users || []).forEach(u => {
            if (!item.organizations.find(o => o === u.organizationName)) {
              item.organizations.push(u.organizationName)
            }
            if (!item.users.find(o => o === u.realName)) {
              item.users.push(u.realName)
            }
            if (!item.mobiles.find(m => m === u.username)) {
              item.mobiles.push(u.username)
            }
          });
          (item.customer?.serviceMans || []).forEach(s => {
            item.sOrganizations.push(s.organizationName)
          })
          item.organizations = item.organizations.join('，')
          item.sOrganizations = item.sOrganizations.join('，')
          item.users = item.users.join('，')
          item.mobiles = item.mobiles.join('，')
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          item.status = item.status.split(',')
          return item
        })
        this.pagination.current = current
        this.pagination.total = total
        this.pagination.pageSize = size
        for (let q in this.query) {
          this.highLightInfo[q] = this.query[q]
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isTableLoading = false
      }
    },
    async exportData() {
      this.isExporting = true
      try {
        const params = {
          query: [],
          filter: [],
          sort: [
            {
              field: 'updatedAt',
              value: 'desc'
            }
          ]
        }
        for (let key in this.query) {
          if (this.query[key]) {
            params.query.push({
              field: key,
              value: key === 'code' ? this.query[key].split('-').join('') : this.query[key]
            })
          }
        }
        for (let fi in this.filters) {
          if (this.filters[fi]) {
            if (Array.isArray(this.filters[fi])) {
              params.filter.push({
                field: fi,
                req: "in",
                value: this.filters[fi]
              })
            } else {
              params.filter.push({
                field: fi,
                value: this.filters[fi]
              })
            }
          }
        }
        for (let f in this.filterDatas) {
          if (this.filterDatas[f].value) {
            params.filter.push({
              field: f,
              req: this.filterDatas[f].req,
              value: +this.filterDatas[f].value
            })
          }
        }
        params.filter.push({
          field: "mode",
          value: "and"
        })
        const { data } = await exportDevice(params)
        const url = window.URL.createObjectURL(
          new Blob([data])
        )
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        const timestamp = new Date().toLocaleDateString()
        link.download = `设备列表${timestamp}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success(this.$t('messages.es'))
      } catch(e) {
        console.log(e)
      } finally {
        this.isExporting = false
      }
    },
    handlePageChange(p) {
      this.pagination.current = p
      this.getCompressorList()
    },
    gotoDevice(device) {
      this.$store.commit('setDeviceInfo', device)
      this.$router.push({ path: '/equipment/list/submit/edit', query: { key: 'monitor' } })
    }
  }
}
</script>

<style>

</style>